/* LTB — L'heure de la boutique, pas celle de l'appareil.

   Les comptes à rebours du calendrier (bannière d'accueil `ltb-avent.js`,
   page liste d'attente `ltb-cda.js`, fiche `ltb-calendrier.js`) basculent à
   9 h et à midi, heure de Paris. Les échéances sont saisies avec leur décalage
   (« +02:00 »), donc un client à l'étranger compte déjà jusqu'au même instant.
   Restait l'horloge de l'appareil : un téléphone en avance de cinq minutes
   voyait le bouton, ou la redirection, cinq minutes trop tôt (Sébastien,
   21/09/2026 : « utilise l'heure de Paris »).

   Une requête au serveur, au chargement : l'en-tête `Date` de sa réponse donne
   l'heure de Shopify, dont on tire l'écart avec l'appareil. La réponse est une
   section vide (`sections/ltb-horloge.liquid`) demandée avec un paramètre
   anti-cache : aucune page mise en cache ne peut renvoyer une heure passée.
   L'en-tête est à la seconde près, d'où la demi-seconde ajoutée.

   `ltbHeure.pret` se résout toujours, au plus tard en 3 secondes : sans
   réseau, on retombe sur l'horloge de l'appareil plutôt que de figer le
   compte à rebours. */
(() => {
  if (window.ltbHeure) return;

  let ecart = 0;

  const synchroniser = async () => {
    try {
      const racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const t0 = Date.now();
      const reponse = await fetch(`${racine}?section_id=ltb-horloge&t=${t0}`, {
        cache: 'no-store',
        credentials: 'same-origin',
      });
      const t1 = Date.now();
      const serveur = Date.parse(reponse.headers.get('Date') || '');
      if (!Number.isNaN(serveur)) ecart = serveur + 500 - (t0 + t1) / 2;
    } catch (e) {
      /* réseau coupé : l'horloge de l'appareil fera foi */
    }
  };

  const pret = Promise.race([
    synchroniser(),
    new Promise((resolve) => { setTimeout(resolve, 3000); }),
  ]).then(() => ecart);

  window.ltbHeure = {
    maintenant: () => Date.now() + ecart,
    pret,
  };
})();
